
    import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
    import {mapActions, mapGetters, mapState} from 'vuex';
    import moment from 'moment';
    import { VMenu } from '@/types/Components';
    import {PatientenstatistikDetailiertOptions} from '@/store/statistik';

    @Component({
        computed: {
            ...mapState('statistik', ['loaders']),
            ...mapState('globals', ['rules']),
            ...mapGetters('authentication', ['isAllowed']),
        },
        methods: {
            ...mapActions('statistik', ['printPatientenstatistikDetailiert']),
        },
    })
    export default class Patientenstatistik_Detailiert extends Vue {
        @Prop() public visible!: boolean;

        public $refs!: {
            zeitraumMenu: VMenu;
        };

        public printPatientenstatistikDetailiert!: (payload: { options: PatientenstatistikDetailiertOptions }) => void;

        public zeitraumMenu = false;

        public options: PatientenstatistikDetailiertOptions = {
            zeitraum: [
                moment().subtract(30, 'days').format('YYYY-MM-DD'),
                moment().format('YYYY-MM-DD'),
            ],
            variante: 'besuche_gesamt',
            gruppierung: 'tag',
        };

        public get canPrint(): boolean {
            return this.options.zeitraum.length === 2;
        }

        public get maxZeitraum(): string {
            return moment().format('YYYY-MM-DD');
        }

        public get maxJahrgang(): number {
            return moment().year();
        }

        public get zeitraumLabel(): string {
            return this.options.zeitraum.length
                ? 'von ' + this.options.zeitraum.sort((a, b) => a.localeCompare(b)).map((date) => {
                    const [year, month, day] = date.split('-');
                    return `${day}.${month}.${year}`;
                }).join(' bis ')
                : '';
        }

        @Watch('zeitraum')
        public onChangeZeitraum(dates: [string, string]): void {
            if (dates?.length === 2) {
                this.options.zeitraum = dates;
            }
        }

        public saveZeitraum(date: [string, string]): void {
            this.options.zeitraum = date;
            this.$refs.zeitraumMenu.save(date);
        }

        public onClickPrint(): void {
            const options = {
                ...this.options,
                zeitraum: this.options.zeitraum.sort((a, b) => a.localeCompare(b)),
            };

            this.printPatientenstatistikDetailiert({ options });
        }

        public get getTitle() {
            return 'Patientenstatistik';
        }
    }
